/** Maps the selected snap index to a 0–1 thumb position (resets to 0 after the last slide). */
export function getCarouselThumbScrollRatio(
	selectedIndex: number,
	snapCount: number,
): number {
	if (snapCount <= 1) {
		return 0;
	}
	const clampedIndex = Math.max(0, Math.min(selectedIndex, snapCount - 1));
	return clampedIndex / (snapCount - 1);
}
